import { ACTION_DEFINE, ACTION_TYPES } from "./constants";

const convertActionTypes = (moduleName: ACTION_DEFINE) => {
  return ACTION_TYPES[moduleName];
};

const convertObjToQueryString = (obj: Record<string, any>) => {
  const filterObj: any = {};
  for (const p in obj) {
    const isValidQuery = obj[p] !== undefined && obj[p] !== null && obj[p] !== "";
    if (Object.prototype.hasOwnProperty.call(obj, p) && isValidQuery) {
      filterObj[p] = obj[p];
    }
  }
  return new URLSearchParams(filterObj).toString();
};

const formatCurrency = (amount: number) => {
  if (amount !== undefined && amount !== null) {
    return amount.toLocaleString("vi-VN");
  }
  return "N/A";
};

export { convertActionTypes, convertObjToQueryString, formatCurrency };

